/* SiloreParis — accessibility widget */
(function () {
  'use strict';

  var toggle = document.querySelector('[data-a11y-toggle]');
  var panel = document.querySelector('[data-a11y-panel]');
  if (!toggle || !panel) return;

  var root = document.documentElement;
  var STORAGE_KEY = 'silore_a11y';
  var state = { fontStep: 0, classes: {} };

  var TOGGLE_CLASSES = ['a11y-contrast', 'a11y-grayscale', 'a11y-links', 'a11y-readable', 'a11y-bigcursor', 'a11y-stop-anim'];

  function load() {
    try {
      var saved = JSON.parse(localStorage.getItem(STORAGE_KEY));
      if (saved) state = saved;
    } catch (e) {}
  }
  function save() { localStorage.setItem(STORAGE_KEY, JSON.stringify(state)); }

  function apply() {
    // font scaling
    var base = parseFloat(getComputedStyle(root).getPropertyValue('--font-size-base')) || 17;
    if (state.fontStep) root.style.fontSize = (100 + state.fontStep * 10) + '%';
    else root.style.fontSize = '';
    // toggles
    TOGGLE_CLASSES.forEach(function (cls) {
      root.classList.toggle(cls, !!state.classes[cls]);
    });
    // reflect active buttons
    panel.querySelectorAll('[data-a11y-class]').forEach(function (b) {
      b.classList.toggle('is-active', !!state.classes[b.dataset.a11yClass]);
      b.setAttribute('aria-pressed', state.classes[b.dataset.a11yClass] ? 'true' : 'false');
    });
  }

  // open/close panel
  function openPanel() { panel.classList.add('is-open'); toggle.setAttribute('aria-expanded', 'true'); panel.setAttribute('aria-hidden', 'false'); var f = panel.querySelector('button'); if (f) f.focus(); }
  function closePanel() { panel.classList.remove('is-open'); toggle.setAttribute('aria-expanded', 'false'); panel.setAttribute('aria-hidden', 'true'); }
  toggle.addEventListener('click', function () {
    panel.classList.contains('is-open') ? closePanel() : openPanel();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePanel(); });
  document.addEventListener('click', function (e) {
    if (panel.classList.contains('is-open') && !panel.contains(e.target) && !toggle.contains(e.target)) closePanel();
  });

  // font buttons
  panel.querySelectorAll('[data-a11y-font]').forEach(function (b) {
    b.addEventListener('click', function () {
      var dir = b.dataset.a11yFont === 'up' ? 1 : -1;
      state.fontStep = Math.max(-2, Math.min(4, state.fontStep + dir));
      apply(); save();
    });
  });

  // class toggle buttons
  panel.querySelectorAll('[data-a11y-class]').forEach(function (b) {
    b.addEventListener('click', function () {
      var cls = b.dataset.a11yClass;
      state.classes[cls] = !state.classes[cls];
      apply(); save();
    });
  });

  // reset
  var reset = panel.querySelector('[data-a11y-reset]');
  if (reset) reset.addEventListener('click', function () {
    state = { fontStep: 0, classes: {} };
    root.style.fontSize = '';
    apply(); save();
  });

  load();
  apply();
})();
